var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckBoxChecked(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#6A993A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3670_34367",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 16,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3670_34367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3671 14.1L16.0171 8.45C16.1505 8.31667 16.306 8.25 16.4838 8.25C16.6616 8.25 16.8171 8.31667 16.9505 8.45C17.0838 8.58333 17.1505 8.74167 17.1505 8.925C17.1505 9.10833 17.0838 9.26667 16.9505 9.4L10.8338 15.5333C10.7005 15.6667 10.5449 15.7333 10.3671 15.7333C10.1894 15.7333 10.0338 15.6667 9.90046 15.5333L7.0338 12.6667C6.90046 12.5333 6.83657 12.375 6.84213 12.1917C6.84769 12.0083 6.91713 11.85 7.05046 11.7167C7.1838 11.5833 7.34213 11.5167 7.52546 11.5167C7.7088 11.5167 7.86713 11.5833 8.00046 11.7167L10.3671 14.1Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxChecked);
export default __webpack_public_path__ + "static/media/checkBoxChecked.45825ec3093f39d8ce515bf77c086528.svg";
export { ForwardRef as ReactComponent };